/* eslint-disable */
import { createStore as createReduxStore } from 'redux';
import { persistStore } from 'redux-persist';
import createEnhancer from './Enhancer';
import createInitialState from './InitialState';
import createReducers from './Reducers';

/**
 * Creates a state management store
 * @param {Services} services The services to inject into the reducers. **NOT** THE STORE.
 * @param {Entry} entry The entry to inject into the reducers. **NOT** THE STORE.
 * @param {ReactHistory} history The history implementation
 * @param {Array<Subscriber>} [subscribers=[]] The `subscribers` that should `subscribe` to the store
 * @returns {{ persistor: Persistor, store: Store }} The newly created state management store
 */
const createStore = (services, entry, history, subscribers = []) => {
  const store = createReduxStore(createReducers(services, entry, history), createInitialState(services), createEnhancer(services, history));
  store.subscribe(() => {
    const state = store.getState();
    subscribers.forEach((subsriber) => {
      subsriber(state);
    });
  });
  const persistor = persistStore(store);
  return { persistor, store };
};

export default createStore;
